import React from 'react';
import ConversationListCard from '@app/components/presentational/MessagingResponsive/ConversationListCard';
import InfiniteTable from '@app/components/presentational/common/InfiniteTable';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectorsResponsive,
  operationsResponsive,
} from '@app/store/conversations';
import { Box, Divider } from '@ublend-npm/aulaui-core';
import { mutedConversations } from '@core/notifications/selectors';
import { NAVIGATION_SOURCE_MESSAGES_VIEW_ALL_MODAL } from '@core/constants/analytics';
import { trackHomeMessagesWidgetItemClicked } from '../../common';

interface Conversation {
  id: string;
  closed?: boolean;
  [key: string]: unknown;
}

interface AllConversationsViewProps {
  handleConversationClick: (conversationId: string, closed?: boolean) => void;
}

const AllConversationsView: React.FC<AllConversationsViewProps> = ({
  handleConversationClick,
}) => {
  const dispatch = useDispatch();

  const loadingMoreConversations = useSelector(
    selectorsResponsive.loadingMoreConversations
  );
  const totalCount = useSelector((state: any) =>
    selectorsResponsive.totalCount(state)
  );
  const conversations = useSelector<unknown, Conversation[]>(
    selectorsResponsive.paginatedConversations
  );
  const mutedConversation = useSelector(mutedConversations);

  return (
    <Box
      sx={{
        height: 'calc(100vh - 200px)',
        '-webkit-height': 'calc(100dvh - 200px)',
      }}
    >
      <InfiniteTable
        items={conversations}
        keyExtractor={(conversation) => conversation.id}
        renderItem={(conversation: Conversation, index: number) => (
          <Box>
            <ConversationListCard
              conversation={conversation}
              conversationMuted={!!mutedConversation?.[conversation.id]}
              selected={false}
              onClick={() => {
                trackHomeMessagesWidgetItemClicked(
                  conversation.id,
                  NAVIGATION_SOURCE_MESSAGES_VIEW_ALL_MODAL,
                  index
                );
                handleConversationClick(conversation.id, conversation?.closed);
              }}
            />
            <Divider sx={{ marginBlock: 1 }} />
          </Box>
        )}
        hasNext={totalCount > conversations.length}
        loadNext={() => {
          const nextPage = Math.floor(conversations.length / 20) + 1;
          if (operationsResponsive?.loadMoreConversations) {
            dispatch(
              operationsResponsive.loadMoreConversations(false, nextPage)
            );
          }
        }}
        loading={loadingMoreConversations}
        renderEmptyList={() => null}
        renderHeader={() => null}
        renderFooter={() => null}
        viewStyle={{ width: '100%' }}
      />
    </Box>
  );
};

export default AllConversationsView;
